export default function convertEmailToUsername(email: string) {
  return `${email}@ob`;
}
